import { Text, Flex, Box } from "@chakra-ui/react";
import { AvatarImage } from "../AvatarImage";
import type { CardFooterProps } from "./CardFooter.d";

export const CardFooter = ({ avatarSrc, author, authorsCountry, ...props }: CardFooterProps) => (
  <Flex align="center" {...props}>
    <AvatarImage avatarSrc={avatarSrc} author={author} />
    <Box>
      {author && <Text fontWeight="500"> {author}</Text>}
      {authorsCountry && <Text color="greyscale.500">{authorsCountry}</Text>}
    </Box>
  </Flex>
);
